export default __webpack_public_path__ + "8336424ac8f45600a1fc18bd15f281fb.png";